import type { StandardTokenType } from "@/features/bridge/types/token-selector.types";
import { create } from "zustand";

interface StandardTokenStoreType {
  tokensFound: boolean;
  setTokensFound: (val: boolean) => void;
  selectedToken: StandardTokenType | undefined;
  setSelectedToken: (token: StandardTokenType | undefined) => void;
  tokenAmount: number;
  setTokenAmount: (amount: number) => void;
  clearStandardTokenState: () => void;
  removeSentTokens: () => void;
}

export const useStandardTokenManager = create<StandardTokenStoreType>(
  (set, get) => ({
    tokensFound: false,
    setTokensFound: (val) => set({ tokensFound: val }),
    selectedToken: undefined,
    setSelectedToken: (token) => set({ selectedToken: token }),
    tokenAmount: 0,
    setTokenAmount: (amount) => set({ tokenAmount: amount }),
    clearStandardTokenState: () =>
      set({ selectedToken: undefined, tokenAmount: 0 }),
    removeSentTokens: () => set({}),
  }),
);
